<template>
    <y-panel
        :title="summary ? element.title : null"
        :subtitle="summary ? `(${digitHelper(totalAnswers)})` : null"
        class="field form-wizard-custom-label form-wizard-radio"
    >
        <template
            v-if="summary"
            slot="functions"
        >
            <y-button
                type="button"
                size="sm"
                @click.prevent="downloadChart('radioChart')"
            >
                {{ $t('form-maker.responses.buttons.download_chart') }}
            </y-button>
        </template>

        <template v-if="summary">
            <y-chart
                ref="radioChart"
                class="answer-pie"
                :series="series"
                :options="chartOptions"
            />
        </template>

        <template v-if="component">
            <template v-if="answers && answers.length">
                <p
                    v-for="(answer, index) in answers"
                    :key="index"
                    class="answer-input is-component"
                >
                    <span>
                        <span
                            v-for="(item, i) in answer.value"
                            :key="i"
                            class="answer-value"
                        >
                            {{ item }}
                        </span>
                    </span>
                    <span class="answer-count">{{ answer.count | digits }}</span>
                </p>
            </template>

            <template v-else>
                <y-empty-state
                    height="150"
                    class="mb0"
                    no-image
                    :title="$t('form-maker.responses.individual.empty_response')"
                />
            </template>
        </template>

        <template v-else-if="!summary && !component">
            <label :class="{'required': element.is_required}">
                {{ element.title }}
                <span
                    v-if="!element.is_required && !readonly"
                    class="form-wizard-radio-clear"
                    @click="clear"
                >{{ `(${$t('form-maker.question.fields.radio.clear_selection')})` }}</span>
            </label>
            <y-form-field
                v-model="model.value"
                type="radio"
                :options="options"
                :validation="element.is_required ? 'required' : ''"
                :disabled="readonly"
                no-label
            />
        </template>
    </y-panel>
</template>

<script>
    import { digits } from '@nodes/helpers/number';
    import TypeFrontMixin from '@/modules/form-maker/mixins/TypeFront';
    import YChart from '@deps/Chart';

    export default {
        name: 'FormMakerPreviewRadio',

        components: {
            YChart,
        },

        mixins: [TypeFrontMixin],

        computed: {
            /**
             * Total of the Answers
             */
            totalAnswers() {
                let count = 0;
                Object.keys(this.answers).forEach((key) => {
                    count += this.answers[key].value;
                });
                return count;
            },

            /**
             * Generate options
             */
            options() {
                const options = {};
                Object.keys(this.element.options).forEach((key) => {
                    this.$set(options, `${this.element.options[key].id}`, `${this.element.options[key].title}`);
                });
                return options;
            },

            /**
             * Label of the Chart
             */
            labels() {
                return Object.keys(this.answers).map((i) => this.answers[i].title);
            },

            /**
             * Options of the Chart
             */
            chartOptions() {
                const options = {
                    legend: {
                        orient   : 'vertical',
                        left     : 'left',
                        textStyle: {
                            fontFamily: this.$i18n.locale === 'fa' ? '"Vazir", sans-serif' : 'sans-serif',
                        },
                    },
                };
                return options;
            },

            /**
             * Series of the Chart
             */
            series() {
                const data = this.answers;
                return [
                    {
                        name : this.title,
                        type : 'pie',
                        label: {
                            show      : true,
                            position  : 'outside',
                            color     : 'rgba(96, 125, 139, 1)',
                            fontFamily: '"Vazir", sans-serif',
                            formatter : ((params) => `${params.data.name}: ${digits((params.percent), this.$i18n.locale)}% (${digits(params.data.value, this.$i18n.locale)})`),
                        },
                        data,
                    },
                ];
            },
        },

        /**
         * Add Answer to the model
         */
        created() {
            if (this.answers) {
                Object.keys(this.answers).forEach((key) => {
                    this.$set(this.model, 'value', this.answers[key]);
                });
            }
        },

        methods: {
            /**
             * Clear Selection
             */
            clear() {
                this.model.value = null;
            },
        },
    };

</script>
